import type { SortableFieldKey } from '../query/type';
const DEVICE_INVENTORY_SORT_COLUMNS = ['DeviceName', 'DeviceSerialNumber', 'AssetTag', 'DeviceTag', 'ModelName'] as const satisfies readonly SortableFieldKey[];
export function isDeviceInventorySortColumn(value: string | undefined): value is SortableFieldKey {
  return value !== undefined && (DEVICE_INVENTORY_SORT_COLUMNS as readonly string[]).includes(value);
}
export { DEVICE_INVENTORY_SORT_COLUMNS };